import { render, staticRenderFns } from "./AspectTableList.vue?vue&type=template&id=421b5787&scoped=true&"
import script from "./AspectTableList.vue?vue&type=script&lang=js&"
export * from "./AspectTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b5787",
  null
  
)

export default component.exports